import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArkUnitOfWork, AppInformationService, DataService } from 'app/core/core.module';
import { ContributionBatch, Contribution, ContributionLine } from 'app/core/model/entity-model';
import { confirm, alert } from 'devextreme/ui/dialog';
import moment from 'moment';
import _ from 'lodash';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-bank-amount-dialog',
    templateUrl: './bank-amount-dialog.component.html',
    styleUrls: ['./bank-amount-dialog.component.scss'],
    standalone: false,
})
export class BankAmountDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    routerOption: any;
    batch: any;
    batchId: number;
    contributionId: any;
    contributions: ContributionItem[] = [];
    contribution: ContributionItem;
    givingTypes: any[];
    people: any[];
    types: any[];
    otherAccounts: any[];
    specialAccountId: number;

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, private appInfo: AppInformationService, private dataService: DataService) {}

    async ngOnInit() {
        this.contributions = [];
        this.batch = await this.uow.contributionBatches.byId(this.batchId);

        if (!this.batch.deposited) this.batch.deposited = new Date();
        if (!this.batch.bankCashAmount) this.batch.bankCashAmount = 0;
        if (!this.batch.bankCheckAmount) this.batch.bankCheckAmount = 0;

        this.contribution = new ContributionItem();
        this.contribution.accountId = this.specialAccountId;
        this.contribution.givingTypeId = 1;
    }

    add() {
        this.contribution.id = this.contributions.length + 1;
        this.contribution.timeStamp = new Date(Date.now());

        this.contribution.givingName = (_(this.types).find({ id: this.contribution.givingTypeId } as any) as any).name;
        this.contribution.personName = (_(this.people).find({ id: this.contribution.personId } as any) as any).name;

        console.log(this.contribution);
        this.contributions.push(this.contribution);

        this.contribution = new ContributionItem();
        this.contribution.accountId = this.specialAccountId;
        this.contribution.givingTypeId = 1;
    }

    async save() {
        await this.uow.commit();
        this.result.next({ result: true });
        this.modalRef.hide();
    }

    async cancel() {
        this.uow.rollback();
        this.modalRef.hide();
    }
}
class ContributionItem {
    id: number;
    accountId: number;
    givingTypeId: number;
    givingName: string;
    personName: string;
    personId: number;
    amount: number;
    timeStamp: Date;

    constructor() {}
}
